import { take } from 'lodash';
import moment from 'moment';
import { CompanyType, Count, RoleType, UserStatus, UserType } from 'api/models';
import {
  ApprovalObjectType,
  ApprovalPreview,
  DocumentPreview,
  ProjectConversationPreview,
  NotificationStatus,
  SpaceTabPreview,
  Start,
  StatusUpdatePreview,
  TaskPreview,
  User,
  UserTimesheetPreview,
} from 'api/notifications';
import {
  ApprovalRequestApproved,
  ApprovalRequestChangesRequested,
  ApprovalRequested,
  DependentTaskChanged,
  DocumentCreated,
  EventType,
  MessageCreated,
  MessageReplyAdded,
  MessageReactionAdded,
  ProjectCsatAdded,
  ProjectNameChanged,
  ProjectPhaseDueDateChanged,
  ProjectPhaseNameChanged,
  ProjectPhaseStartDateChanged,
  ProjectPhaseStatusChanged,
  ProjectStatusChanged,
  ProjectConversationMemberAdded,
  ProjectConversationMemberInvited,
  TaskAssignedToUser,
  TaskAssigneeChanged,
  TaskAtRiskChanged,
  TaskAttachmentChanged,
  TaskCreated,
  TaskFieldChanged,
  TaskStartDateChanged,
  TaskStatusChanged,
  UserMentionedInDocument,
  UserMentionedInMesage,
  UserMentionedInTask,
  TaskPrivateNoteChanged,
  ProjectDeleted,
  ProjectArchived,
  ProjectUnarchived,
  TaskPhaseChanged,
} from 'api/notifications/meta';
import { ProjectReference } from 'api/notifications/references';
import { Project } from 'api/project';
import { StatusGroup, TaskType } from 'api/tasks';
import {
  ActionableGroup,
  FetchedLastPage,
  FetchInfo,
  Loaded,
  NotificationCount,
} from 'stores/notifications/models';

const container: ProjectReference = {
  projectId: 1,
  uri: '/projects/1',
  uuid: '',
};

const by: User = {
  userId: 1,
  firstName: 'Seth',
  lastName: 'Rogen',
  defaultCapacity: true,
  capacity: 40,
  company: {
    capacity: 40,
    companyId: 1,
    companyName: 'Segment',
    companyType: CompanyType.Vendor,
  },
  emailId: 'seth@segment.io',
  userStatus: UserStatus.Active,
  userType: UserType.External,
};

export const other: User = {
  userId: 5,
  firstName: 'Sudarsan',
  lastName: 'Balaji',
  defaultCapacity: true,
  capacity: 40,
  company: {
    capacity: 40,
    companyId: 1,
    companyName: 'Segment',
    companyType: CompanyType.Vendor,
  },
  emailId: 'sudarsan@rocketlane.com',
  userStatus: UserStatus.Active,
  userType: UserType.External,
};

export const users: User[] = [
  {
    userId: 4,
    firstName: 'Kannan',
    lastName: 'Shanmugham',
    defaultCapacity: true,
    capacity: 40,
    company: {
      capacity: 40,
      companyId: 1,
      companyName: 'Rocketlane',
      companyType: CompanyType.Vendor,
    },
    emailId: 'kannan@rocketlane.com',
    userStatus: UserStatus.Active,
    userType: UserType.External,
  },
  {
    userId: 3,
    firstName: 'Srikrishnan',
    lastName: 'Ganesan',
    defaultCapacity: true,
    capacity: 40,
    company: {
      capacity: 40,
      companyId: 1,
      companyName: 'Rocketlane',
      companyType: CompanyType.Vendor,
    },
    emailId: 'sri@rocketlane.com',
    userStatus: UserStatus.Active,
    userType: UserType.External,
  },
  {
    userId: 2,
    firstName: 'Vignesh',
    lastName: 'Girishankar',
    defaultCapacity: true,
    capacity: 40,
    company: {
      capacity: 40,
      companyId: 1,
      companyName: 'Rocketlane',
      companyType: CompanyType.Vendor,
    },
    emailId: 'vignesh@rocketlane.com',
    userStatus: UserStatus.Active,
    userType: UserType.External,
  },
  {
    userId: 1,
    firstName: 'Sudarsan',
    lastName: 'Balaji',
    defaultCapacity: true,
    capacity: 40,
    company: {
      capacity: 40,
      companyId: 1,
      companyName: 'Rocketlane',
      companyType: CompanyType.Vendor,
    },
    emailId: 'sudarsan@rocketlane.com',
    userStatus: UserStatus.Active,
    userType: UserType.External,
  },
  other,
];

export const content = FetchedLastPage(
  FetchInfo(Count(1), Start(), NotificationCount(1)),
  [
    Loaded({
      key: '/project-conversations/1',
      clear: () => {},
      status: NotificationStatus.New,
      conversation: {
        id: 1,
        conversationName: 'Chargebee Release Plan - General',
        private: false,
        project: { id: 235, name: 'Project Chargebee' },
        conversationId: 456,
        memberIds: [2, 3],
      } as ProjectConversationPreview,
      notifications: [
        {
          container,
          meta: {
            eventType: EventType.ProjectConversationMemberAdded,
            by,
            conversationName: 'Chargebee Release Plan - General',
          } as ProjectConversationMemberAdded,
        },
        {
          container,
          meta: {
            eventType: EventType.ProjectConversationMemberInvited,
            by,
            conversationName: 'Chargebee Release Plan - General',
          } as ProjectConversationMemberInvited,
        },
        {
          container,
          meta: {
            eventType: EventType.MessageCreated,
            by,
            message: {
              content:
                '<p>Will be fixed via <a target="_blank" rel="noopener noreferrer" href="https://github.com/Rocketlane/rocket-frontend/pull/2761">Fix invalid filters breaking criteria by artfuldev · Pull Request #2761 · Rocketlane/rocket-frontend (github.com)</a></p>',
            },
          } as MessageCreated,
        },
        {
          container,
          meta: {
            eventType: EventType.UserMentionedInMessage,
            by,
            message: {
              content:
                '<p><a class="rl__mention" data-rocketlane-mention-type="USER" data-rocketlane-mention-project-id="398" data-rocketlane-mention-object-id="125" data-mention="Sudarsan  Balaji" href="#">Sudarsan &nbsp;Balaji</a> will take care of adding created by field in all task list and filters. With that assumption, i unassigned myself from this task.</p>',
            },
          } as UserMentionedInMesage,
        },
        {
          container,
          meta: {
            eventType: EventType.MessageReplyAdded,
            by,
            message: {
              content:
                'This is a really really long message for us to test how it works, actually. This can be multiline or whatever. It will be longer than 3 lines to show the style',
            },
            reply: {
              content:
                'This is a really really long reply for us to test how it works, actually. This can be multiline or whatever. It will be longer than 3 lines to show the style',
            },
          } as MessageReplyAdded,
        },
        {
          container,
          meta: {
            eventType: EventType.MessageReactionAdded,
            by,
            message: {
              content: 'This will work',
            },
            reaction: '👍',
          } as MessageReactionAdded,
        },
      ],
    } as unknown as ActionableGroup),
    Loaded({
      key: '/status-updates/1',
      clear: () => {},
      status: NotificationStatus.New,
      statusUpdate: {
        id: 1,
        name: '05 Mar Status Update',
        autoPublished: true,
        project: {
          id: 1,
          name: 'Some project name',
        },
      } as StatusUpdatePreview,
      notifications: [],
    } as unknown as ActionableGroup),
    Loaded({
      key: '/users/1/timesheets',
      timesheet: {
        userId: 1,
        approverIds: [2, 3],
      } as UserTimesheetPreview,
      clear: () => {},
      status: NotificationStatus.New,
      notifications: [
        {
          meta: {
            eventType: EventType.TimesheetSubmitted,
            start: '2021-06-21',
            by: other,
          },
        },
      ],
    } as unknown as ActionableGroup),
    Loaded({
      key: '/users/5/timesheets',
      timesheet: {
        userId: other.userId,
        approverIds: [1, 2, 3],
      } as UserTimesheetPreview,
      clear: () => {},
      status: NotificationStatus.New,
      notifications: [
        {
          meta: {
            eventType: EventType.TimesheetApproved,
            start: '2021-06-21',
            by,
          },
        },
        {
          meta: {
            eventType: EventType.TimesheetRequested,
            start: '2021-06-21',
            by,
          },
        },
        {
          meta: {
            eventType: EventType.TimesheetOverdueReminder,
            start: '2021-06-21',
          },
        },
        {
          meta: {
            eventType: EventType.TimesheetDueReminder,
            start: '2021-06-21',
          },
        },
      ],
    } as unknown as ActionableGroup),
    Loaded({
      key: '/tasks/1',
      clear: () => {},
      status: NotificationStatus.New,
      task: {
        id: 1,
        name: 'A really good but really really really long task name that will most definitely get truncated',
        dueDate: moment().toISOString(),
        status: 1,
        progress: 30,
        priority: 1,
        project: { id: 1, name: 'Project Coolio', private: false },
      } as TaskPreview,
      notifications: [
        {
          container,
          meta: {
            eventType: EventType.TaskAssigneeChanged,
            by,
            additions: take(users, 1),
          } as TaskAssigneeChanged,
        },
        {
          container,
          meta: {
            eventType: EventType.TaskAssigneeChanged,
            by,
            additions: take(users, 2),
          } as TaskAssigneeChanged,
        },
        {
          container,
          meta: {
            eventType: EventType.TaskAssigneeChanged,
            by,
            additions: take(users, 3),
          } as TaskAssigneeChanged,
        },
        {
          container,
          meta: {
            eventType: EventType.TaskAssigneeChanged,
            by,
            additions: users,
          } as TaskAssigneeChanged,
        },
        {
          container,
          meta: {
            eventType: EventType.DependentTaskChanged,
            by,
            addition: {
              taskId: 2,
              taskName: 'A dependent task',
              project: {
                projectId: 1,
              },
            },
          } as DependentTaskChanged,
        },
        {
          container,
          meta: {
            eventType: EventType.DependentTaskChanged,
            by,
            removal: {
              taskId: 3,
              taskName: 'Another dependent task',
            },
          } as DependentTaskChanged,
        },
        {
          container,
          meta: {
            eventType: EventType.TaskAttachmentChanged,
            by,
            addition: {
              name: 'An attachment.docx',
            },
          } as TaskAttachmentChanged,
        },
        {
          container,
          meta: {
            eventType: EventType.TaskAttachmentChanged,
            by,
            removal: {
              name: 'Another attachment.pdf',
            },
          } as TaskAttachmentChanged,
        },
        {
          container,
          meta: {
            eventType: EventType.UserMentionedInMessage,
            by,
            message: {
              content:
                '<p><a class="rl__mention" data-rocketlane-mention-type="USER" href="#">Peter Parker</a> pasted the datadog link <a href="#">https://app.datadoghq.com/rum/error%tracking?eventSrc=rum&issueId=0cdf1cac%0fcb%11ec%84aa%da7ad0900002&start=1640608728572&end=1640695128572&paused=falsef1cac%0fcb%11ec%84aa%da7ad0900002&start=1640608728572&end=1640695128572&paused=falsef1cac%0fcb%11ec%84aa%da7ad0900002&start=1640608728572&end=1640695128572&paused=false</a> and more content</p>',
            },
          } as UserMentionedInMesage,
        },
        {
          container,
          meta: {
            eventType: EventType.UserMentionedInMessage,
            by,
            message: {
              content:
                '<p><a class="rl__mention" data-rocketlane-mention-type="USER" data-rocketlane-mention-project-id="398" data-rocketlane-mention-object-id="125" data-mention="Sudarsan  Balaji" href="#">Sudarsan &nbsp;Balaji</a> will take care of adding created by field in all task list and filters. With that assumption, i unassigned myself from this task.</p>',
            },
          } as UserMentionedInMesage,
        },
        {
          container,
          meta: {
            eventType: EventType.UserMentionedInTask,
            by,
            preview:
              '<p><a class="rl__mention" data-rocketlane-mention-type="USER" data-rocketlane-mention-project-id="398" data-rocketlane-mention-object-id="125" data-mention="Sudarsan  Balaji" href="#">Sudarsan &nbsp;Balaji</a> will take care of adding created by field in all task list and filters. With that assumption, i unassigned myself from this task.</p>',
          } as UserMentionedInTask,
        },
        {
          container,
          meta: {
            eventType: EventType.MessageCreated,
            by,
            message: {},
          } as MessageCreated,
        },
        {
          container,
          meta: {
            eventType: EventType.MessageCreated,
            by,
            message: {
              content:
                '<p>Will be fixed via <a target="_blank" rel="noopener noreferrer" href="https://github.com/Rocketlane/rocket-frontend/pull/2761">Fix invalid filters breaking criteria by artfuldev · Pull Request #2761 · Rocketlane/rocket-frontend (github.com)</a></p>',
            },
          } as MessageCreated,
        },
        {
          container,
          meta: {
            eventType: EventType.TaskAtRiskChanged,
            by,
            atRisk: true,
          } as TaskAtRiskChanged,
        },
        {
          container,
          meta: {
            eventType: EventType.TaskStatusChanged,
            by,
            from: {
              label: 'In Progress',
              group: StatusGroup.InProgress,
            },
            to: {
              label: 'Cannot proceed',
              group: StatusGroup.Blocked,
            },
          } as TaskStatusChanged,
        },
        {
          container,
          meta: {
            eventType: EventType.TaskDependencyStatusChanged,
            by,
            association: {
              taskId: 234435,
              taskName: 'Clean current Database',
              project: {
                projectId: 234,
              },
              fields: [
                {
                  fieldId: 5573,
                  fieldName: 'Status',
                  fieldType: 'SINGLE_SELECT',
                  fieldDataType: 'TEXT',
                  customField: true,
                  optionsAvailable: true,
                  fieldValue: 3,
                  metaFieldValue: {
                    color: 'green',
                    label: 'Completed',
                    value: 3,
                    position: 3,
                    group: 3,
                    active: true,
                    deletable: false,
                    editable: false,
                  },
                  objectType: 'TASK',
                  metaData: {
                    options: [
                      {
                        color: 'blue',
                        label: 'To do',
                        value: 1,
                        position: 1,
                        group: 1,
                        active: true,
                        deletable: false,
                        editable: false,
                      },
                      {
                        color: 'green',
                        label: 'In progress',
                        value: 2,
                        position: 2,
                        group: 2,
                        active: true,
                        deletable: false,
                        editable: false,
                      },
                      {
                        color: 'green',
                        label: 'Completed',
                        value: 3,
                        position: 3,
                        group: 3,
                        active: true,
                        deletable: false,
                        editable: false,
                      },
                      {
                        color: 'cool-gray',
                        label: 'Blocked',
                        value: 4,
                        position: 4,
                        group: 4,
                        active: true,
                        deletable: false,
                        editable: false,
                      },
                    ],
                    rangeAvailable: false,
                    default: 1,
                  },
                  fieldLabel: 'Status',
                  isEnabled: true,
                  private: false,
                },
              ],
            },
          },
        },
        {
          container,
          meta: {
            eventType: EventType.TaskAtRiskChanged,
            by,
            atRisk: false,
          } as TaskAtRiskChanged,
        },
        {
          container,
          meta: {
            eventType: EventType.MessageReplyAdded,
            by,
            message: {
              content:
                'This is a really really long message for us to test how it works, actually. This can be multiline or whatever. It will be longer than 3 lines to show the style',
            },
            reply: {
              content:
                'This is a really really long reply for us to test how it works, actually. This can be multiline or whatever. It will be longer than 3 lines to show the style',
            },
          } as MessageReplyAdded,
        },
        {
          container,
          timestamp: moment().add(-1, 'hour').toISOString(),
          meta: {
            eventType: EventType.TaskPrivateNoteChanged,
            by,
          } as TaskPrivateNoteChanged,
        },
        {
          container,
          timestamp: moment().add(-1, 'day').toISOString(),
          meta: {
            eventType: EventType.MessageReplyAdded,
            by,
            message: {
              content:
                'This is a really really long message for us to test how it works, actually. This can be multiline or whatever. It will be longer than 3 lines to show the style',
            },
            reply: {
              content:
                'This is a really really long reply for us to test how it works, actually. This can be multiline or whatever. It will be longer than 3 lines to show the style',
            },
          } as MessageReplyAdded,
        },
        {
          container,
          timestamp: moment().add(-1, 'day').toISOString(),
          meta: {
            by,
            name: 'Accountable',
            from: {
              type: 'User',
              value: {
                userId: 1,
                firstName: 'Deepak',
                lastName: 'Bala',
              },
            },
            to: {
              type: 'User',
              value: {
                userId: 2,
                firstName: 'Vignesh',
                lastName: 'Girishankar',
              },
            },
            eventType: EventType.TaskFieldChanged,
          } as TaskFieldChanged,
        },
        {
          container,
          timestamp: moment().add(-1, 'day').toISOString(),
          meta: {
            by,
            name: 'Like This',
            from: {
              type: 'Boolean',
              value: false,
            },
            to: {
              type: 'Boolean',
              value: true,
            },
            eventType: EventType.TaskFieldChanged,
          } as TaskFieldChanged,
        },
        {
          container,
          timestamp: moment().add(-1, 'day').toISOString(),
          meta: {
            by,
            name: 'Responsible',
            addition: {
              type: 'User',
              value: {
                userId: 1,
                firstName: 'Deepak',
                lastName: 'Bala',
              },
            },
            eventType: EventType.TaskFieldChanged,
          } as TaskFieldChanged,
        },
        {
          container,
          timestamp: moment().add(-1, 'day').toISOString(),
          meta: {
            by,
            name: 'Responsible',
            removal: {
              type: 'User',
              value: {
                userId: 1,
                firstName: 'Deepak',
                lastName: 'Bala',
              },
            },
            eventType: EventType.TaskFieldChanged,
          } as TaskFieldChanged,
        },
      ],
    } as unknown as ActionableGroup),
    Loaded({
      key: '/documents/1',
      clear: () => {},
      status: NotificationStatus.New,
      document: {
        id: 1,
        name: 'A really good document',
        private: false,
        project: { id: 234, name: 'Project Coolio' },
        space: { id: 345, name: 'OneDrive' },
        tabId: 456,
        collaborators: [by, other],
      } as DocumentPreview,
      notifications: [
        {
          container,
          meta: {
            eventType: EventType.UserMentionedInDocument,
            by,
            preview:
              '<p><a class="rl__mention" data-rocketlane-mention-type="USER" data-rocketlane-mention-project-id="398" data-rocketlane-mention-object-id="125" data-mention="Sudarsan  Balaji" href="#">Sudarsan &nbsp;Balaji</a> will take care of adding created by field in all task list and filters. With that assumption, i unassigned myself from this task.</p>',
          } as UserMentionedInDocument,
        },
        {
          container,
          meta: {
            eventType: EventType.DocumentCreated,
            by,
            title: 'A really good document',
          } as DocumentCreated,
        },
      ],
    } as unknown as ActionableGroup),
    Loaded({
      key: '/documents/2',
      clear: () => {},
      status: NotificationStatus.New,
      document: {
        id: 2,
        private: false,
        project: { id: 234, name: 'Project Coolio' },
        space: { id: 345, name: 'OneDrive' },
        tabId: 456,
        collaborators: [by, other],
      } as DocumentPreview,
      notifications: [],
    } as unknown as ActionableGroup),
    Loaded({
      key: '/tasks/2',
      clear: () => {},
      status: NotificationStatus.New,
      task: {
        id: 2,
        name: 'Another really good task name',
        status: 2,
        progress: 20,
        assignee: {
          users: [
            {
              userId: 1,
              firstName: 'John',
              lastName: 'Watson',
            },
          ] as unknown as User[],
          teams: [],
        },
        project: { id: 1, name: 'Project Coolio', private: false },
        projectPhase: { id: 1, name: 'Phaserio' },
        type: TaskType.Milestone,
        atRisk: false,
        private: false,
      } as TaskPreview,
      notifications: [
        {
          container,
          meta: {
            eventType: EventType.TaskStatusChanged,
            by,
            from: {
              label: 'In progress',
              group: StatusGroup.InProgress,
            },
            to: {
              label: 'To do',
              group: StatusGroup.Todo,
            },
          } as TaskStatusChanged,
        },
        {
          container,
          meta: {
            eventType: EventType.TaskStatusChanged,
            by,
            from: {
              label: 'In progress',
              group: StatusGroup.InProgress,
            },
            to: {
              label: 'Completed',
              group: StatusGroup.Completed,
            },
          } as TaskStatusChanged,
        },
        {
          container,
          meta: {
            eventType: EventType.TaskCreated,
            by,
            title: 'Long task name is not getting truncated in notifications',
          } as TaskCreated,
        },
        {
          container,
          meta: {
            eventType: EventType.TaskAssignedToUser,
            by: {
              firstName: 'Vigneshwaranramasamy',
            },
            title: 'Long task name is not getting truncated in notifications',
          } as TaskAssignedToUser,
        },
        {
          container,
          meta: {
            eventType: EventType.TaskStartDateChanged,
            by,
            from: {
              type: 'Date',
              value: moment().add(-1, 'day').toISOString(),
            },
            to: {
              type: 'Date',
              value: moment().add(-2, 'day').toISOString(),
            },
          } as TaskStartDateChanged,
        },
      ],
    } as unknown as ActionableGroup),
    Loaded({
      key: '/tasks/2',
      clear: () => {},
      status: NotificationStatus.New,
      task: {
        id: 2,
        name: 'Another really good task name',
        status: 2,
        progress: 20,
        assignee: {
          users: [
            {
              userId: 1,
              firstName: 'John',
              lastName: 'Watson',
            },
          ] as unknown as User[],
          teams: [],
        },
        project: { id: 1, name: 'Project Coolio', private: false },
        projectPhase: { id: 1, name: 'Phaserio' },
        type: TaskType.Milestone,
        atRisk: false,
        private: false,
      } as TaskPreview,
      notifications: [
        {
          container,
          meta: {
            eventType: EventType.TaskPhaseChanged,
            by,
            from: {
              value: 'Demo phase',
            },
            to: {
              value: 'Different phase',
            },
          } as TaskPhaseChanged,
        },
        {
          container,
          meta: {
            eventType: EventType.TaskPhaseChanged,
            by,
            to: {
              value: 'Demo phase',
            },
          } as TaskPhaseChanged,
        },
        {
          container,
          meta: {
            eventType: EventType.TaskStatusChanged,
            by,
            from: {
              label: 'In progress',
              group: StatusGroup.InProgress,
            },
            to: {
              label: 'Completed',
              group: StatusGroup.Completed,
            },
          } as TaskStatusChanged,
        },
        {
          container,
          meta: {
            eventType: EventType.TaskCreated,
            by,
            title: 'Long task name is not getting truncated in notifications',
          } as TaskCreated,
        },
        {
          container,
          meta: {
            eventType: EventType.TaskAssignedToUser,
            by: {
              firstName: 'Vigneshwaranramasamy',
            },
            title: 'Long task name is not getting truncated in notifications',
          } as TaskAssignedToUser,
        },
        {
          container,
          meta: {
            eventType: EventType.TaskStartDateChanged,
            by,
            from: {
              type: 'Date',
              value: moment().add(-1, 'day').toISOString(),
            },
            to: {
              type: 'Date',
              value: moment().add(-2, 'day').toISOString(),
            },
          } as TaskStartDateChanged,
        },
      ],
    } as unknown as ActionableGroup),
    Loaded({
      key: '/projects/1',
      clear: () => {},
      status: NotificationStatus.New,
      project: {
        projectName: 'Reebok New Shoe Launch',
        customer: {
          companyId: 2,
          companyName: 'Reebok',
        },
      } as Partial<Project>,
      notifications: [
        {
          container,
          meta: {
            eventType: EventType.ProjectPhaseStartDateChanged,
            by,
            phaseName: 'Phase A',
            from: {
              type: 'Date',
              value: moment().add(-1, 'day').toISOString(),
            },
            to: {
              type: 'Date',
              value: moment().add(-2, 'day').toISOString(),
            },
          } as ProjectPhaseStartDateChanged,
        },
        {
          container,
          meta: {
            eventType: EventType.ProjectPhaseDueDateChanged,
            by,
            phaseName: 'Really really long name of a phase',
            from: {
              type: 'Date',
              value: moment().add(-1, 'day').toISOString(),
            },
            to: {
              type: 'Date',
              value: moment().add(-2, 'day').toISOString(),
            },
          } as ProjectPhaseDueDateChanged,
        },
        {
          container,
          meta: {
            eventType: EventType.ProjectPhaseNameChanged,
            by,
            phaseName: 'Phase A',
            from: {
              type: 'Text',
              value: 'Really realy long name of a phase',
            },
            to: {
              type: 'Text',
              value: 'Slightly less long name of a phase',
            },
          } as ProjectPhaseNameChanged,
        },
      ],
    } as unknown as ActionableGroup),
    Loaded({
      key: '/projects/1',
      clear: () => {},
      status: NotificationStatus.New,
      project: {
        projectName: 'Test project',
        projectId: 123,
        customer: {
          companyId: 2,
          companyName: 'Nike',
          companyLogoUrl:
            'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASoAAACpCAMAAACrt4DfAAAAe1BMVEURERH///8AAAAODg4LCwsGBgbs7OzV1dWWlpbk5OQICAj6+vo2NjbExMS0tLSjo6MiIiJJSUlQUFAVFRWioqLz8/NxcXHf39/Z2dmqqqpBQUFra2tlZWXLy8uFhYU9PT18fHxMTEwoKChYWFiKioqwsLCamprGxsYvLy8Cbkz3AAACjElEQVR4nO3Zh5KCMBSFYXPBir3jWlh11fd/wuUidqzLzDLk/x4gY87kJDEUCgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgGTf9IWu19MfMAOmkm5UjIt1uL9Uxs0H6PSe1wTSmwrzhd4upDZkd0q9IOiNpTO70p+T125LLpAIjaSyqYpjTd6VszCgIA0thwMyRlfH/vKh0OdXnjYExptmRVJLPHll6pv6nsmhMMmyWwpjMoNKTlMqcOY6UTPXzyTnaulVrZCLjYU6bF5GG+bh/tTCmSWXm7XOKmpfuj8sUWYdzHH4wQ23dLog2p0gpx82LyESnuXh3q9LN6eunao7KuW6eciSabvuNWUabU7c/Nmeai7yeeSfi60y93qtRuXolWB83p7h5ku/mRfb1M2b5SlS6OS2DRslc0OblfUEpiWvUeboqdHOa+lVzJedn3olM4xk//geoV4LvTfk6pvC26VoSVBjVYZXcv4Lq5rRbb72bnMz4K+9n3pnjojImSMpKN6d2/H/lpnkTaxaUktlp6vXrievmtPJHSTHl/7Z5zW2fzd7rnj0v6c2pUykntE6VbWrenswvK1WXg/gxJZENt80bsr3u1dbfbPzGODGiuHmSy7fNJxy5u3Lu0OZZt6CUu3wvKMvOvHPSeSOnUqVgbVDRi/o7zbPszLvwclR65v33j/1fxfqrzbPwzLv0ygloe/MObu5VSc2z8nJw4/FmZelt8w79rPWgeSyoE/1YmsSz+LZ5T9G5eQEOF1Rgw1eFt9WkdZXTuk3zkjlSiN+lvMGsNRXuBg/o43l7MdlFD1Wsp2fcYtElJQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABnfgF1AxYyGda22QAAAABJRU5ErkJggg==',
        },
      } as Partial<Project>,
      notifications: [
        {
          container,
          meta: {
            eventType: EventType.ProjectDeleted,
            by: {
              role: {
                roleId: 2,
                roleName: 'Engineer',
                type: RoleType.Vendor,
              },
              userId: 2,
              defaultCapacity: true,
              capacity: 40,
              company: {
                capacity: 40,
                companyId: 2,
                companyName: 'Segment',
                companyLogoUrl:
                  'https://www.google.com/imgres?imgurl=https%3A%2F%2Flogos-download.com%2Fwp-content%2Fuploads%2F2016%2F12%2FAxis_Bank_logo_logotype.png&imgrefurl=https%3A%2F%2Flogos-download.com%2F12851-axis-bank-logo-download.html&tbnid=aoMQWwX5JfRb1M&vet=12ahUKEwjDwMOPpsDuAhX65HMBHRFvAhsQMygBegUIARDJAQ..i&docid=QFXFSicQNmKVbM&w=4570&h=1239&q=axis%20logo&ved=2ahUKEwjDwMOPpsDuAhX65HMBHRFvAhsQMygBegUIARDJAQ',
                companyType: CompanyType.Vendor,
              },
              emailId: 'kannan@rocketlane.com',
              isActive: false,
              lastName: 'Shanmugam',
              photoUrl: 'https://randomuser.me/api/portraits/men/58.jpg',
              userName: 'kannan',
              userType: 'NATIVE',
              firstName: 'Kannan',
              userStatus: 'ACTIVE',
              identityType: 'USER',
            },
          } as ProjectDeleted,
        },
        {
          container,
          meta: {
            eventType: EventType.ProjectArchived,
            by: {
              role: {
                roleId: 2,
                roleName: 'Engineer',
                type: RoleType.Vendor,
              },
              userId: 2,
              defaultCapacity: true,
              capacity: 40,
              company: {
                capacity: 40,
                companyId: 2,
                companyName: 'Segment',
                companyType: CompanyType.Vendor,
                companyLogoUrl:
                  'https://www.google.com/imgres?imgurl=https%3A%2F%2Flogos-download.com%2Fwp-content%2Fuploads%2F2016%2F12%2FAxis_Bank_logo_logotype.png&imgrefurl=https%3A%2F%2Flogos-download.com%2F12851-axis-bank-logo-download.html&tbnid=aoMQWwX5JfRb1M&vet=12ahUKEwjDwMOPpsDuAhX65HMBHRFvAhsQMygBegUIARDJAQ..i&docid=QFXFSicQNmKVbM&w=4570&h=1239&q=axis%20logo&ved=2ahUKEwjDwMOPpsDuAhX65HMBHRFvAhsQMygBegUIARDJAQ',
              },
              emailId: 'asim@rocketlane.com',
              isActive: false,
              lastName: 'KT',
              photoUrl: 'https://randomuser.me/api/portraits/men/40.jpg',
              userName: 'asim',
              userType: 'NATIVE',
              firstName: 'Asim',
              userStatus: 'ACTIVE',
              identityType: 'USER',
            },
          } as ProjectArchived,
        },
        {
          container,
          meta: {
            eventType: EventType.ProjectUnarchived,
            by: {
              role: {
                roleId: 2,
                roleName: 'Engineer',
                type: RoleType.Vendor,
              },
              userId: 2,
              defaultCapacity: true,
              capacity: 40,
              company: {
                capacity: 40,
                companyId: 2,
                companyName: 'Segment',
                companyType: CompanyType.Vendor,
                companyLogoUrl:
                  'https://www.google.com/imgres?imgurl=https%3A%2F%2Flogos-download.com%2Fwp-content%2Fuploads%2F2016%2F12%2FAxis_Bank_logo_logotype.png&imgrefurl=https%3A%2F%2Flogos-download.com%2F12851-axis-bank-logo-download.html&tbnid=aoMQWwX5JfRb1M&vet=12ahUKEwjDwMOPpsDuAhX65HMBHRFvAhsQMygBegUIARDJAQ..i&docid=QFXFSicQNmKVbM&w=4570&h=1239&q=axis%20logo&ved=2ahUKEwjDwMOPpsDuAhX65HMBHRFvAhsQMygBegUIARDJAQ',
              },
              emailId: 'arushi@rocketlane.com',
              isActive: false,
              lastName: 'Ladha',
              photoUrl: 'https://randomuser.me/api/portraits/women/58.jpg',
              userName: 'kannan',
              userType: 'NATIVE',
              firstName: 'Arushi',
              userStatus: 'ACTIVE',
              identityType: 'USER',
            },
          } as ProjectUnarchived,
        },
      ],
    } as unknown as ActionableGroup),
    Loaded({
      key: '/projects/1',
      clear: () => {},
      status: NotificationStatus.New,
      project: {
        projectName: 'Some random project name',
        customer: {
          companyId: 2,
        },
      } as Partial<Project>,
      notifications: [],
    } as unknown as ActionableGroup),
    Loaded({
      key: '/status-updates/1',
      clear: () => {},
      status: NotificationStatus.New,
      statusUpdate: {
        id: 1,
        name: '05 Mar Status Update',
        project: {
          id: 1,
          name: 'Some project name',
        },
      } as StatusUpdatePreview,
      notifications: [],
    } as unknown as ActionableGroup),
    Loaded({
      key: '/space-tabs/1',
      clear: () => {},
      status: NotificationStatus.New,
      spaceTab: {
        id: 1,
        name: 'Initial Mockups',
        logoUrl: 'https://static.figma.com/app/icon/1/icon-192.png',
        project: {
          id: 1,
          name: 'Notifications',
        },
        space: {
          id: 1,
          name: 'Mockups',
        },
      } as SpaceTabPreview,
      notifications: [],
    } as unknown as ActionableGroup),
    Loaded({
      key: '/space-tabs/2',
      clear: () => {},
      status: NotificationStatus.New,
      spaceTab: {
        id: 2,
        name: 'Final Mockups',
        project: {
          id: 1,
          name: 'Notifications',
        },
        space: {
          id: 1,
          name: 'Mockups',
        },
      } as SpaceTabPreview,
      notifications: [],
    } as unknown as ActionableGroup),
    Loaded({
      key: '/projects/1',
      clear: () => {},
      status: NotificationStatus.New,
      project: {
        projectName: 'Nike New Shoe Launch',
        customer: {
          companyId: 2,
          companyName: 'Nike',
          companyLogoUrl:
            'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASoAAACpCAMAAACrt4DfAAAAe1BMVEURERH///8AAAAODg4LCwsGBgbs7OzV1dWWlpbk5OQICAj6+vo2NjbExMS0tLSjo6MiIiJJSUlQUFAVFRWioqLz8/NxcXHf39/Z2dmqqqpBQUFra2tlZWXLy8uFhYU9PT18fHxMTEwoKChYWFiKioqwsLCamprGxsYvLy8Cbkz3AAACjElEQVR4nO3Zh5KCMBSFYXPBir3jWlh11fd/wuUidqzLzDLk/x4gY87kJDEUCgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgGTf9IWu19MfMAOmkm5UjIt1uL9Uxs0H6PSe1wTSmwrzhd4upDZkd0q9IOiNpTO70p+T125LLpAIjaSyqYpjTd6VszCgIA0thwMyRlfH/vKh0OdXnjYExptmRVJLPHll6pv6nsmhMMmyWwpjMoNKTlMqcOY6UTPXzyTnaulVrZCLjYU6bF5GG+bh/tTCmSWXm7XOKmpfuj8sUWYdzHH4wQ23dLog2p0gpx82LyESnuXh3q9LN6eunao7KuW6eciSabvuNWUabU7c/Nmeai7yeeSfi60y93qtRuXolWB83p7h5ku/mRfb1M2b5SlS6OS2DRslc0OblfUEpiWvUeboqdHOa+lVzJedn3olM4xk//geoV4LvTfk6pvC26VoSVBjVYZXcv4Lq5rRbb72bnMz4K+9n3pnjojImSMpKN6d2/H/lpnkTaxaUktlp6vXrievmtPJHSTHl/7Z5zW2fzd7rnj0v6c2pUykntE6VbWrenswvK1WXg/gxJZENt80bsr3u1dbfbPzGODGiuHmSy7fNJxy5u3Lu0OZZt6CUu3wvKMvOvHPSeSOnUqVgbVDRi/o7zbPszLvwclR65v33j/1fxfqrzbPwzLv0ygloe/MObu5VSc2z8nJw4/FmZelt8w79rPWgeSyoE/1YmsSz+LZ5T9G5eQEOF1Rgw1eFt9WkdZXTuk3zkjlSiN+lvMGsNRXuBg/o43l7MdlFD1Wsp2fcYtElJQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABnfgF1AxYyGda22QAAAABJRU5ErkJggg==',
        },
      } as Partial<Project>,
      notifications: [
        {
          container,
          meta: {
            eventType: EventType.ProjectStatusChanged,
            by,
            from: { group: 2, label: 'In Progress' },
            to: { group: 3, label: 'Completed' },
          } as ProjectStatusChanged,
        },
        {
          container,
          meta: {
            eventType: EventType.ProjectNameChanged,
            by,
            from: { type: 'Text', value: 'Something' },
            to: { type: 'Text', value: 'Something else' },
          } as ProjectNameChanged,
        },
        {
          container,
          meta: {
            eventType: EventType.ProjectPhaseStatusChanged,
            by,
            from: { label: 'To do', group: StatusGroup.Todo },
            to: { label: 'In progress', group: StatusGroup.InProgress },
            phaseName: 'Some phase name',
          } as ProjectPhaseStatusChanged,
        },
        {
          container,
          meta: {
            eventType: EventType.ProjectCsatAdded,
            by,
            milestone: 'Project Kickoff',
            rating: 4.5,
            comment: 'Went really fucking awesome!',
          } as ProjectCsatAdded,
        },
        {
          id: 35449,
          container: {
            projectId: 101,
            uuid: '8187f78c-0c7f-5c77-961f-59dbca7f24ef',
            uri: '/projects/101',
          },
          timestamp: '2021-01-29T05:47:16.891460Z',
          sortKey: '1611899236891460.00000000000000035449',
          meta: {
            by: {
              role: {
                roleId: 2,
                roleName: 'Engineer',
              },
              userId: 2,
              company: {
                companyId: 2,
                companyName: 'Segment',
                companyLogoUrl:
                  'https://www.google.com/imgres?imgurl=https%3A%2F%2Flogos-download.com%2Fwp-content%2Fuploads%2F2016%2F12%2FAxis_Bank_logo_logotype.png&imgrefurl=https%3A%2F%2Flogos-download.com%2F12851-axis-bank-logo-download.html&tbnid=aoMQWwX5JfRb1M&vet=12ahUKEwjDwMOPpsDuAhX65HMBHRFvAhsQMygBegUIARDJAQ..i&docid=QFXFSicQNmKVbM&w=4570&h=1239&q=axis%20logo&ved=2ahUKEwjDwMOPpsDuAhX65HMBHRFvAhsQMygBegUIARDJAQ',
              },
              emailId: 'kannan@rocketlane.com',
              isActive: false,
              lastName: 'Shanmugam',
              photoUrl: 'https://randomuser.me/api/portraits/men/58.jpg',
              userName: 'kannan',
              userType: 'NATIVE',
              firstName: 'Kannan',
              userStatus: 'ACTIVE',
              identityType: 'USER',
            },
            title: 'test',
            status: {
              type: 'Text',
              value: 'On Track',
            },
            eventType: 'ProjectStatusUpdatePublished',
          },
          systemRuleIdentifier: 'PUBLISHED_PROJECT_STATUS_UPDATE',
        },
        {
          id: 35307,
          container: {
            projectId: 101,
            uuid: '8187f78c-0c7f-5c77-961f-59dbca7f24ef',
            uri: '/projects/101',
          },
          timestamp: '2021-01-28T17:15:37.850305Z',
          sortKey: '1611854137850305.00000000000000035307',
          meta: {
            by: {
              role: {
                roleId: 2,
                roleName: 'Engineer',
              },
              userId: 2,
              company: {
                companyId: 2,
                companyName: 'Segment',
                companyLogoUrl: 'https://logo.clearbit.com/segment.com',
              },
              emailId: 'kannan@rocketlane.com',
              isActive: false,
              lastName: 'Shanmugam',
              photoUrl: 'https://randomuser.me/api/portraits/men/58.jpg',
              userName: 'kannan',
              userType: 'NATIVE',
              firstName: 'Kannan',
              userStatus: 'ACTIVE',
              identityType: 'USER',
            },
            user: {
              role: {
                roleId: 3,
                roleName: 'Solution Consultant',
              },
              userId: 236,
              company: {
                companyId: 2,
                companyName: 'Segment',
                companyLogoUrl: 'https://logo.clearbit.com/segment.com',
              },
              emailId: 'sd',
              isActive: false,
              userName: 'sd',
              userType: 'EXTERNAL',
              accountId: 1,
              firstName: 'sd',
              userStatus: 'ACTIVE',
              identityType: 'USER',
            },
            eventType: 'ProjectMemberJoinedMyProject',
          },
          systemRuleIdentifier: 'ADDED_PROJECT_TEAM_MEMBER_JOINED_MY_PROJECT',
        },
        {
          id: 35305,
          container: {
            projectId: 101,
            uuid: '8187f78c-0c7f-5c77-961f-59dbca7f24ef',
            uri: '/projects/101',
          },
          timestamp: '2021-01-28T17:14:47.617682Z',
          sortKey: '1611854087617682.00000000000000035305',
          meta: {
            by: {
              role: {
                roleId: 2,
                roleName: 'Engineer',
              },
              userId: 2,
              company: {
                companyId: 2,
                companyName: 'Segment',
                companyLogoUrl: 'https://logo.clearbit.com/segment.com',
              },
              emailId: 'kannan@rocketlane.com',
              isActive: false,
              lastName: 'Shanmugam',
              photoUrl: 'https://randomuser.me/api/portraits/men/58.jpg',
              userName: 'kannan',
              userType: 'NATIVE',
              firstName: 'Kannan',
              userStatus: 'ACTIVE',
              identityType: 'USER',
            },
            user: {
              role: {},
              userId: 346,
              company: {
                companyId: 1,
                companyName: 'Nike',
                companyLogoUrl: 'https://logo.clearbit.com/nike.com',
              },
              emailId: 'sample2@nike.com',
              isActive: false,
              userName: 'sample2',
              userType: 'EXTERNAL',
              accountId: 1,
              firstName: 'sample2@nike.com',
              userStatus: 'ACTIVE',
              identityType: 'USER',
            },
            eventType: 'ProjectMemberJoinedMyProject',
          },
          systemRuleIdentifier: 'ADDED_PROJECT_TEAM_MEMBER_JOINED_MY_PROJECT',
        },
        {
          id: 35163,
          container: {
            projectId: 101,
            uuid: '8187f78c-0c7f-5c77-961f-59dbca7f24ef',
            uri: '/projects/101',
          },
          timestamp: '2021-01-28T11:38:36.797475Z',
          sortKey: '1611833916797475.00000000000000035163',
          meta: {
            by: {
              role: {
                roleId: 2,
                roleName: 'Engineer',
              },
              userId: 2,
              company: {
                companyId: 2,
                companyName: 'Segment',
                companyLogoUrl: 'https://logo.clearbit.com/segment.com',
              },
              emailId: 'kannan@rocketlane.com',
              isActive: false,
              lastName: 'Shanmugam',
              photoUrl: 'https://randomuser.me/api/portraits/men/58.jpg',
              userName: 'kannan',
              userType: 'NATIVE',
              firstName: 'Kannan',
              identityType: 'USER',
            },
            user: {
              role: {},
              userId: 400,
              company: {
                companyId: 1,
                companyName: 'Nike',
                companyLogoUrl: 'https://logo.clearbit.com/nike.com',
              },
              emailId: 'sample12@rocketNike.com',
              isActive: false,
              lastName: 'sample12',
              userName: 'sample12',
              userType: 'EXTERNAL',
              accountId: 1,
              firstName: 'sample12',
              identityType: 'USER',
            },
            eventType: 'ProjectMemberJoinedMyProject',
          },
          systemRuleIdentifier: 'ADDED_PROJECT_TEAM_MEMBER_JOINED_MY_PROJECT',
        },
        {
          id: 35166,
          container: {
            projectId: 101,
            uuid: '8187f78c-0c7f-5c77-961f-59dbca7f24ef',
            uri: '/projects/101',
          },
          timestamp: '2021-01-28T11:38:36.797475Z',
          sortKey: '1611833916797475.00000000000000035163',
          meta: {
            by: {
              role: {
                roleId: 1,
                roleName: 'Designer',
              },
              userId: 1,
              company: {
                companyId: 2,
                companyName: 'Segment',
                companyType: 'CUSTOMER',
                identityType: 'COMPANY',
                companyLogoUrl:
                  'https://www.pngkey.com/maxpic/u2a9o0u2e6i1w7r5',
              },
              emailId: 'dev@rocketlane.com',
              lastName: 'Curry',
              photoUrl: 'random.jpg',
              timeZone: 'Asia/Calcutta',
              userName: 'Dev',
              userType: 'NATIVE',
              createdAt: 1684222986977,
              firstName: 'Dev',
              loginType: 'USER',
              userStatus: 'ACTIVE',
              identityType: 'USER',
            },
            team: {
              roleId: 103,
              teamId: 14,
              resolved: false,
              teamName: 'Project Manager',
              teamType: 'NATIVE',
              userList: [],
              identityType: 'TEAM',
            },
            company: {
              capacity: 40,
              companyId: 3,
              createdAt: 1684243260446,
              strategic: true,
              companyUrl: 'https://www.gainsight.com',
              companyName: 'Divergent',
              companyType: 'PARTNER',
              identityType: 'COMPANY',
              companyLogoUrl: 'https://logo.clearbit.com/gainsight.com',
            },
            eventType: 'ProjectPlaceholderResolve',
          },
          systemRuleIdentifier: 'PLACEHOLDER_RESOLVE',
        },
        {
          id: 36164,
          container: {
            projectId: 6,
            uuid: 'ff3a0232-d996-5ec2-99e9-df2b7abac455',
            uri: '/projects/6',
            type: 'projects',
          },
          timestamp: '2023-02-13T12:21:38.723Z',
          sortKey: '1676290898723000.00000000000000000007',
          meta: {
            by: {
              role: {
                roleId: 1,
                roleName: 'Designer',
              },
              userId: 1,
              company: {
                companyId: 2,
                companyName: 'Segment',
                companyLogoUrl:
                  'https://www.pngkey.com/maxpic/u2a9o0u2e6i1w7r5',
              },
              emailId: 'dev@rocketlane.com',
              lastName: 'Curry',
              photoUrl: 'random.jpg',
              timeZone: 'Asia/Calcutta',
              userName: 'Dev',
              userType: 'NATIVE',
              createdAt: 1676270475337,
              firstName: 'Dev',
              loginType: 'USER',
              userStatus: 'ACTIVE',
              identityType: 'USER',
            },
            companyList: [
              {
                companyId: 200,
                companyName: 'Modert LLC',
                companyLogoUrl:
                  'https://www.pngkey.com/maxpic/u2a9o0u2e6i1w7r5',
              },
              {
                companyId: 201,
                companyName: 'Chargebee',
                companyLogoUrl:
                  'https://www.pngkey.com/maxpic/u2a9o0u2e6i1w7r5',
              },
              {
                companyId: 202,
                companyName: 'Zelerius',
                companyLogoUrl:
                  'https://www.pngkey.com/maxpic/u2a9o0u2e6i1w7r5',
              },
            ],
            eventType: 'ProjectPartnerAddition',
          },
        },
        {
          id: 37164,
          container: {
            projectId: 6,
            uuid: 'ff3a0232-d996-5ec2-99e9-df2b7abac455',
            uri: '/projects/6',
            type: 'projects',
          },
          timestamp: '2023-02-13T12:21:38.723Z',
          sortKey: '1676290898723000.00000000000000000007',
          meta: {
            by: {
              role: {
                roleId: 1,
                roleName: 'Designer',
              },
              userId: 1,
              company: {
                companyId: 2,
                companyName: 'Segment',
                companyLogoUrl:
                  'https://www.pngkey.com/maxpic/u2a9o0u2e6i1w7r5',
              },
              emailId: 'dev@rocketlane.com',
              lastName: 'Curry',
              photoUrl: 'random.jpg',
              timeZone: 'Asia/Calcutta',
              userName: 'Dev',
              userType: 'NATIVE',
              createdAt: 1676270475337,
              firstName: 'Dev',
              loginType: 'USER',
              userStatus: 'ACTIVE',
              identityType: 'USER',
            },
            companyList: [
              {
                companyId: 200,
                companyName: 'Modert LLC',
                companyLogoUrl:
                  'https://www.pngkey.com/maxpic/u2a9o0u2e6i1w7r5',
              },
            ],
            eventType: 'ProjectPartnerAddition',
          },
        },
        {
          id: 35164,
          container: {
            projectId: 101,
            uuid: '8187f78c-0c7f-5c77-961f-59dbca7f24ef',
            uri: '/projects/101',
          },
          timestamp: '2021-01-28T11:38:36.797475Z',
          sortKey: '1611833916797475.00000000000000035163',
          meta: {
            by: {
              role: {
                roleId: 2,
                roleName: 'Engineer',
              },
              userId: 2,
              company: {
                companyId: 2,
                companyName: 'Segment',
                companyLogoUrl: 'https://logo.clearbit.com/segment.com',
              },
              emailId: 'kannan@rocketlane.com',
              isActive: false,
              lastName: 'Shanmugam',
              photoUrl: 'https://randomuser.me/api/portraits/men/58.jpg',
              userName: 'kannan',
              userType: 'NATIVE',
              firstName: 'Kannan',
              identityType: 'USER',
            },
            eventType: EventType.UserAddedToProject,
          },
          systemRuleIdentifier: 'ADDED_PROJECT_TEAM_MEMBER_JOINED_MY_PROJECT',
        },
      ],
    } as unknown as ActionableGroup),
    Loaded({
      key: '/approvals/1',
      clear: () => {},
      status: NotificationStatus.New,
      approval: {
        task: {
          id: 19572,
          name: 'A really good but really really really long task name that will most definitely get truncated',
          dueDate: moment().toISOString(),
          status: 1,
          progress: 30,
          priority: 1,
          project: { id: 1792, name: 'Project Coolio', private: false },
        } as TaskPreview,
        dueDate: '2021-04-30T11:38:36.797475Z',
        approverIds: [1],
        actedUpon: true,
        approvalObjectType: ApprovalObjectType.Task,
      } as ApprovalPreview,
      notifications: [
        {
          container,
          meta: {
            eventType: EventType.ApprovalRequestApproved,
            by: {
              userId: 2,
              firstName: 'Vignesh',
              lastName: 'Girishankar',
              company: {
                companyId: 1,
                companyName: 'Rocketlane',
              },
              emailId: 'vignesh@rocketlane.com',
              userStatus: UserStatus.Active,
              userType: UserType.External,
            } as User,
          } as ApprovalRequestApproved,
          timestamp: '2021-01-28T11:38:36.797475Z',
        },
        {
          container,
          meta: {
            eventType: EventType.ApprovalRequestChangesRequested,
            by,
          } as ApprovalRequestChangesRequested,
          timestamp: '2021-01-28T11:38:36.797475Z',
        },
        {
          container,
          meta: {
            eventType: EventType.ApprovalRequested,
            by: {
              userId: 1,
              firstName: 'Sudarsan',
              lastName: 'Balaji',
              company: {
                companyId: 1,
                companyName: 'Rocketlane',
              },
              emailId: 'sudarsan@rocketlane.com',
              userStatus: UserStatus.Active,
              userType: UserType.External,
            },
            message: {
              content:
                'The lease document have been sent out to Christopher. Need approval on procuring the materials.',
            },
          } as ApprovalRequested,
          timestamp: '2021-01-28T11:38:36.797475Z',
        },
      ],
    } as unknown as ActionableGroup),
    Loaded({
      key: '/approvals/2',
      clear: () => {},
      status: NotificationStatus.New,
      approval: {
        task: {
          id: 1,
          name: 'A really good but really really really long task name that will most definitely get truncated',
          dueDate: moment().toISOString(),
          status: 1,
          progress: 30,
          priority: 1,
          project: { id: 1, name: 'Project Coolio', private: false },
        } as TaskPreview,
        dueDate: '2021-05-30T11:38:36.797475Z',
        approverIds: [1, 2],
        actedUpon: true,
        approvalObjectType: ApprovalObjectType.Task,
      } as ApprovalPreview,
      notifications: [
        {
          container,
          meta: {
            eventType: EventType.ApprovalRequestApproved,
            by: {
              userId: 2,
              firstName: 'Vignesh',
              lastName: 'Girishankar',
              company: {
                companyId: 1,
                companyName: 'Rocketlane',
              },
              emailId: 'vignesh@rocketlane.com',
              userStatus: UserStatus.Active,
              userType: UserType.External,
            } as User,
            message: {
              content: 'Nice Job! Looks good to me, approving it.',
            },
          } as ApprovalRequestApproved,
          timestamp: '2021-01-28T11:38:36.797475Z',
        },
        {
          container,
          meta: {
            eventType: EventType.ApprovalRequestChangesRequested,
            by: {
              userId: 1,
              firstName: 'Sudarsan',
              lastName: 'Balaji',
              company: {
                companyId: 1,
                companyName: 'Rocketlane',
              },
              emailId: 'sudarsan@rocketlane.com',
              userStatus: UserStatus.Active,
              userType: UserType.External,
            },
            message: {
              content:
                '<a class="rl__mention" data-rocketlane-mention-type="USER" data-rocketlane-mention-project-id="1792" data-rocketlane-mention-object-id="1559" data-rocketlane-mention-identifier="665b99de-1e57-4d55-a8eb-4fb022019e28" data-mention="Jane Cooper" href="#">Jane Cooper</a> I feel that we should add a diagram about the user journey to make it better. Can you please incoporate that?',
            },
          } as ApprovalRequestChangesRequested,
          timestamp: '2021-01-28T11:38:36.797475Z',
        },
        {
          container,
          meta: {
            eventType: EventType.ApprovalRequested,
            by,
            message: {
              content:
                "Worked on this but not sure if it's the right approach to go ahead. If you could look at it and direct me to the right direction then, I can make more corrections on it.",
            },
          } as ApprovalRequested,
          timestamp: '2021-01-28T11:38:36.797475Z',
        },
      ],
    } as unknown as ActionableGroup),
    Loaded({
      key: '/approvals/3',
      clear: () => {},
      status: NotificationStatus.New,
      approval: {
        document: {
          id: 1,
          name: 'A really good document',
          private: false,
          project: { id: 234, name: 'Project Coolio' },
          space: { id: 345, name: 'OneDrive' },
          tabId: 456,
          collaborators: [by, other],
        } as DocumentPreview,
        dueDate: '2021-05-30T11:38:36.797475Z',
        approverIds: [1, 2, 3, 4, 5],
        actedUpon: false,
        approvalObjectType: ApprovalObjectType.Document,
      } as ApprovalPreview,
      notifications: [
        {
          container,
          meta: {
            eventType: EventType.ApprovalRequestApproved,
            by: {
              userId: 2,
              firstName: 'Vignesh',
              lastName: 'Girishankar',
              company: {
                companyId: 1,
                companyName: 'Rocketlane',
              },
              emailId: 'vignesh@rocketlane.com',
              userStatus: UserStatus.Active,
              userType: UserType.External,
            } as User,
            message: {
              content: 'Nice Job! Looks good to me, approving it.',
            },
          } as ApprovalRequestApproved,
          timestamp: '2021-01-28T11:38:36.797475Z',
        },
        {
          container,
          meta: {
            eventType: EventType.ApprovalRequestChangesRequested,
            by: {
              userId: 1,
              firstName: 'Sudarsan',
              lastName: 'Balaji',
              company: {
                companyId: 1,
                companyName: 'Rocketlane',
              },
              emailId: 'sudarsan@rocketlane.com',
              userStatus: UserStatus.Active,
              userType: UserType.External,
            },
            message: {
              content:
                '<a class="rl__mention" data-rocketlane-mention-type="USER" data-rocketlane-mention-project-id="1792" data-rocketlane-mention-object-id="1559" data-rocketlane-mention-identifier="665b99de-1e57-4d55-a8eb-4fb022019e28" data-mention="Jane Cooper" href="#">Jane Cooper</a> I feel that we should add a diagram about the user journey to make it better. Can you please incoporate that?',
            },
          } as ApprovalRequestChangesRequested,
          timestamp: '2021-01-28T11:38:36.797475Z',
        },
        {
          container,
          meta: {
            eventType: EventType.ApprovalRequested,
            by,
            message: {
              content:
                "Worked on this but not sure if it's the right approach to go ahead. If you could look at it and direct me to the right direction then, I can make more corrections on it.",
            },
          } as ApprovalRequested,
          timestamp: '2021-01-28T11:38:36.797475Z',
        },
      ],
    } as unknown as ActionableGroup),
  ],
  moment.utc().add(-1, 'hours'),
);
